module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading/heading_3-90773bb9e6a36e10b53a75dd1a364cff.png";